<template>
  <div class="py-10 bg-brand-6 lg:py-20 dark:bg-grey-10">
    <div class="container <lg:space-y-6" :class="{ 'lg:grid lg:cols-3 lg:gap-x-10 lg:gap-y-15': productFeatures }">
      <template v-if="productFeatures">
        <div class="space-y-4">
          <h2 class="elevate-title-2">
            {{ heading }}
          </h2>
          <p class="elevate-body-2">
            {{ description }}
          </p>
        </div>
        <div v-if="productFeatures" class="lg:col-span-3">
          <p class="elevate-title-4 c-grey-20 mb-4 dark:c-grey-70">
            {{ productFeatures.label }}
          </p>
          <vf-carousel
            class-container="gap-2 <lg:-mx-4 <lg:scroll-px-4 <lg:px-4"
            class-controls="!hidden"
            class-wrapper="parent"
          >
            <div
              v-for="({ label, bgImageURL }, i) in highlightedFeatures"
              :key="i"
              v-style="{
                w: {
                  sm: '75vw',
                  lg: `calc(${(1 / highlightedFeatures.length) * 100}% - 0.5rem)`,
                },
              }"
              class="group rounded-lg bg-white relative overflow-hidden"
              style="height: 13.125rem"
            >
              <base-picture
                v-if="bgImageURL"
                class="duration-800 absolute-0 group-hover:scale-105"
                fit="cover"
                :src="{ sm: bgImageURL }"
              />
              <div
                class="c-white p-4 flex gap-1 items-end absolute-0 between lg:p-6"
                style="background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%)"
              >
                <base-button
                  class="elevate-body-1"
                  @click="PanelProductFeatures.open({ productFeatures, active: i })"
                >
                  {{ label }}
                  <span class="absolute-0" />
                </base-button>
                <vf-icon class="pointer-events-none" name="arrow" size="lg" />
              </div>
            </div>
          </vf-carousel>
          <div v-if="productFeatures.data.length > MAX_FEATURES" class="mt-10 flex justify-center">
            <vf-button
              size="xs"
              variant="secondary"
              @click="PanelProductFeatures.open({ productFeatures })"
            >
              {{ $t.viewMoreFeatures }}
            </vf-button>
          </div>
        </div>
      </template>
      <div class="space-y-2 children:px-4 children:b lg:col-span-2 lg:col-start-2 lg:row-start-1">
        <product-accordions :product-details="productDetails.filter(({ id }) => id !== 'productFeatures')" />
      </div>
    </div>
    <panel-product-features class-wrapper="!p-0" />
  </div>
</template>

<script setup lang="ts">
import type { ProductDetails } from '#root/api/clients/product/data-contracts'

const props = defineProps<{
  productDetails: ProductDetails[]
  heading?: string
  description?: string
}>()

const MAX_FEATURES = 5

const productFeatures = computed(() => props.productDetails.find(({ id }) => id === 'productFeatures'))
const highlightedFeatures = computed(() => productFeatures.value?.data.slice(0, MAX_FEATURES) || [])

const PanelProductFeatures = createPanel('product-features')
</script>
